import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { MotNaoCompra } from '../models/mot-nao-compra';

import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MotNaoCompraService {

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
  ) { }

  getMotsNaoComp(cnpj: string): Observable<MotNaoCompra[]> {
    if (cnpj === '') {
      return of([]);
    }

    return this.http.get<MotNaoCompra[]>(environment.vendas + '/motnaocomp/' + cnpj)
      .pipe(
        catchError(err => of(err.error))
      );
  }

  addMotNaoComp(motNaoComp: MotNaoCompra): Observable<MotNaoCompra> {
    return this.http.post<MotNaoCompra>(environment.vendas + '/motnaocomp/' + environment.selected.cnpj,
      motNaoComp, this.httpOptions)
      .pipe(
        catchError(err => of(err.error))
      );
  }

  updateMotNaoComp(id: string, motNaoComp: MotNaoCompra): Observable<MotNaoCompra> {
    return this.http.put<MotNaoCompra>(environment.vendas + '/motnaocomp/' + environment.selected.cnpj + '/' + id,
      motNaoComp, this.httpOptions)
      .pipe(
        catchError(err => of(err.error))
      );
  }
}
